"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeightAnimator = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var react_animate_height_1 = tslib_1.__importDefault(require("react-animate-height"));
var react_transition_group_1 = require("react-transition-group");
var Animation_1 = require("../utils/Animation");
exports.HeightAnimator = function (props) {
    var _a = React.useState(props.initialHeight || 0), transitionHeight = _a[0], setTransitionHeight = _a[1];
    var handleEnter = function () {
        if (props.height === undefined) {
            setTransitionHeight('auto');
        }
    };
    var handleExit = function () {
        setTransitionHeight(0);
    };
    var childrenArray = React.Children.toArray(props.children);
    var firstChildArray = childrenArray.slice(0, 1);
    if (childrenArray.length > 1) {
        console.warn('Multiple children were provided, but only the first child will be rendered');
    }
    React.useEffect(function () {
        if (props.height !== undefined && props.height !== transitionHeight) {
            setTransitionHeight(props.height);
        }
    }, [props.height, transitionHeight]);
    return (React.createElement(react_transition_group_1.TransitionGroup
    // TransitionGroup will not update exiting children's props without a childFactory
    , { 
        // TransitionGroup will not update exiting children's props without a childFactory
        childFactory: function (child) { return React.cloneElement(child, {
            height: transitionHeight,
        }); } }, firstChildArray.map(function (child, id) {
        return React.createElement(react_transition_group_1.Transition, { appear: true, key: id, onEnter: handleEnter, onExit: handleExit, onExited: props.onExitAnimationComplete, timeout: Animation_1.AnimationDuration },
            React.createElement(react_animate_height_1.default, { animateOpacity: true, duration: Animation_1.AnimationDuration, height: transitionHeight }, child));
    })));
};
//# sourceMappingURL=HeightAnimator.js.map